import { Component, Input, OnInit, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { NavController } from '@ionic/angular/lazy';
import { from, map, merge, defer, distinctUntilChanged } from 'rxjs';
import { AuthService } from '../services/authentication.service';
import { UserDTO } from '../entities/dto/user.dto';
import { ServerUrl } from '../services/server-url.service';
import { CurrentCreneauService } from '../services/current-creneau.service';
import { DemandesATraiterService } from '../services/demandes-a-traiter.service';

@Component({
  selector: 'in2-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  standalone: false,
})
export class MenuComponent implements OnInit {
  private readonly navCtrl = inject(NavController);
  private readonly authService = inject(AuthService);
  private readonly serverUrl = inject(ServerUrl);
  public readonly currentCreneauService = inject(CurrentCreneauService);
  private readonly demandesATraiterService = inject(DemandesATraiterService);

  public readonly user = signal<UserDTO | undefined>(undefined);
  public faGear = faCog;
  public faGearOutline = faCog;
  @Input() public contentId = '';

  // Missions Count: shared single source of truth
  public readonly missionsATraiterCount = this.demandesATraiterService.count;

  /**
   * Role Signal:
   * Merging initial check with stream of updates.
   * We use defer to avoid switchMap loop.
   */
  public readonly isResponsable = toSignal(
    merge(
      defer(() => from(this.authService.getUser())),
      this.authService.onUserChange()
    ).pipe(
      map(user => user?.authorities?.includes(AuthService.ROLE_RESPONSABLE) ?? false),
      distinctUntilChanged()
    ),
    { initialValue: false }
  );

  public async logout() {
    await this.authService.logout();
    await this.navCtrl.navigateRoot('');
  }

  public openWebapp(): void {
    const url = this.serverUrl.get();
    if (!url) {
      return;
    }
    window.open(url.replace(/(https?:\/\/[^/]+)(.*)/, '$1/'), '_system', 'location=yes');
  }

  public ngOnInit(): void {
    this.authService.onUserChange().subscribe(user => this.user.set(user));
    this.authService.getUser().then(user => this.user.set(user));
  }
}
